// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging,getToken } from "firebase/messaging";
import notificationServices from "./notificationServices";

const firebaseConfig = {
  apiKey: "AIzaSyD6he1kXx4kjb_mq0Sa7EL_r6cUL83ijYE",
  authDomain: "ghelp-b6f18.firebaseapp.com",
  projectId: "ghelp-b6f18",
  storageBucket: "ghelp-b6f18.firebasestorage.app",
  messagingSenderId: "850861728678",
  appId: "1:850861728678:web:5461cc27f0b509b172e567",
  measurementId: "G-8WDFH67T81"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Messaging to app 
export const messaging = getMessaging(app);


export const generateFCMToken = async () => {
    const permission = await Notification.requestPermission();
    if(permission === "granted"){
        const fcmToken = await getToken(messaging,{
            vapidKey:"BKMaZCz8GkDaiuSyMeTRo606plQfLCMObiLvmsgtcR7L20r5USqzDICJnW9qYzXAST7tVQ-ZC9bjzdpRXHUJxdI"
        })
        let phone = localStorage.getItem('guestPhone');
        if(phone && !sessionStorage.getItem('fcmRegistered')){
            let payload = {
                fcmToken: fcmToken,
                phone:phone
            }
            notificationServices.registerFcmToken(payload).then(res=>{
                sessionStorage.setItem("fcmRegistered",true);
            }).catch(error=>{

            })
        } else{
            //console.log("fcm alreday resistered")
        }
    }
    
}




/*

import { generateToken, messaging } from './global-whatsapp/notifications/firbase';
import { onMessage } from 'firebase/messaging';

useEffect(()=>{
    generateToken();
    onMessage(messaging,(payload)=>{
        console.log(payload);
    })
},[])

*/








/*
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD6he1kXx4kjb_mq0Sa7EL_r6cUL83ijYE",
  authDomain: "ghelp-b6f18.firebaseapp.com",
  projectId: "ghelp-b6f18",
  storageBucket: "ghelp-b6f18.firebasestorage.app",
  messagingSenderId: "850861728678",
  appId: "1:850861728678:web:5461cc27f0b509b172e567",
  measurementId: "G-8WDFH67T81"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

*/